import { ProductItem } from "../store/BasketStore"
import { SponsoredProductsConfig } from "../types/retail-media"

/**
 * Function to get the maximum number of sponsored products to display on the current page
 * @param { boolean } isSearchPage - whether the current page is a search page
 * @param { SponsoredProductsConfig | null } searchPageConfig - the configuration from the store for the search page
 * @param { SponsoredProductsConfig | null } categoryPageConfig - the configuration from the store for the category page
 * @returns { number } - the maximum number of sponsored products to display or 0 by default
 */
export const getMaxSponsoredProducts = (isSearchPage: boolean, searchPageConfig: SponsoredProductsConfig | null, categoryPageConfig: SponsoredProductsConfig | null) => {
    if (isSearchPage && searchPageConfig) return searchPageConfig.maxNumberOfProducts
    if (!isSearchPage && categoryPageConfig) return categoryPageConfig.maxNumberOfProducts
    return 0
  }

/**
 * Create a string representation of the category tree
 * @param { string[] } categoryTree - an array of category names
 * @returns { string } - a string representation of the category names minus 'Home' which is the first entry
 */
export const createCategoryNameString = (categoryTree: string[]): string => {
  if (!categoryTree) return ''
  return categoryTree.filter((category) => category !== 'Home').join(">")
}

/**
 * Create an array of order items from the products in the basket for Retail Media
 * 
 * @param {ProductItem[]} products - array of products in the basket
 * @returns {ProductItem[]} array of order items
 */
export const createOrderItemsArray = (products: ProductItem[]) => {
  return products.map(product => {
    const price = product.basePrice || 0
    const quantity = product.quantity || 0

    return {
      gtin: product.productId || '',
      quantity,
      regularUnitPrice: price,
      totalOrderItemPriceAfterDiscounts: product.priceAfterItemDiscount
    }
  })
}